import React from 'react';
import { motion } from 'framer-motion';

const Navbar = () => {
  return (
    <motion.nav 
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6 }}
      className="fixed w-full z-50 bg-transparent h-20 flex items-center"
    >
      <div className="container mx-auto px-6 flex justify-end items-center">
        <motion.button 
          whileHover={{ scale: 1.05, backgroundColor: '#15803d' }}
          whileTap={{ scale: 0.95 }}
          onClick={() => window.dispatchEvent(new Event('openModal'))}
          className="bg-green-600 text-white text-sm font-black px-8 py-3 rounded-full shadow-[0_0_20px_rgba(22,163,74,0.4)] transition-all uppercase tracking-widest border border-green-400/30"
        >
          Get Roadmap
        </motion.button>
      </div>
    </motion.nav>
  );
};

export default Navbar;